// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import Vuex from 'vuex';
import BootstrapVue from 'bootstrap-vue';
import fonts from 'google-fonts';
import VueI18n from 'vue-i18n';
import _ from 'lodash';

import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'animate.css/animate.css';

import messages from './assets/i18n/i18n';

import App from './App';
import router from './router';

fonts.add({
  Roboto: ['400', '500'],
});

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(BootstrapVue);

const store = new Vuex.Store({
  state: {
    playlist: false,
    initialHighLight: null,
    player: false,
    highlights: true,
    plays: false,
    players: false,
    loading: true,
  },
  mutations: {
    appReady(state) {
      state.loading = false;
    },
    setPlaylist(state, payload) {
      const playlist = payload;

      playlist.highlights = _.map(playlist.highlights, (hl) => {
        hl.duration = parseInt(hl.name, 10);
        return hl;
      });

      state.playlist = playlist;
    },
    setInitialHighLight(state, payload) {
      state.initialHighLight = payload;
    },
    setHighlights(state, payload) {
      state.highlights = payload;
      state.plays = false;
      state.players = false;
    },
    setPlays(state, payload) {
      state.plays = payload;
      state.players = false;
      state.highlights = false;
    },
    setPlayers(state, payload) {
      state.players = payload;
      state.highlights = false;
      state.plays = false;
    },
    setPlayer(state, payload) {
      state.player = payload;
    },
  },
});

const i18n = new VueI18n({
  locale: 'en',
  messages,
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js